/* ═══════════════════════════════════════
   HUBBELDIDUPP — Theme JS
   Original-Interaktionen + Shopify-Warenkorb
   ═══════════════════════════════════════ */

// ─── Helpers ───
function fmtPrice(cents) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
function hbdForm() { return document.querySelector('form[action="/cart/add"]'); }
function unitCents() {
  var el = document.getElementById('unitPrice');
  return parseInt((el && el.value) || '2495', 10);
}

// ─── Menge ───
var qty = 1;
function chgQ(d) {
  qty = Math.max(1, qty + d);
  var qEl = document.getElementById('q');           if (qEl) qEl.textContent = qty;
  var qInput = document.getElementById('quantity'); if (qInput) qInput.value = qty;
  var cB = document.getElementById('cB');            if (cB) cB.textContent = 'In den Warenkorb · ' + fmtPrice(unitCents() * qty);
}

// ─── Warenkorb-Feedback (visuell) ───
function hbdAdded() {
  var b = document.getElementById('cB');
  var bubble = document.getElementById('cartBubble');
  if (bubble) {
    bubble.textContent = (parseInt(bubble.textContent, 10) || 0) + qty;
    bubble.classList.add('show');
  }
  if (b) {
    b.textContent = '✓ Hinzugefügt';
    b.style.background = 'var(--mint-deep)';
    b.style.color = 'var(--ink)';
    setTimeout(function () {
      b.textContent = 'In den Warenkorb · ' + fmtPrice(unitCents() * qty);
      b.style.background = '';
      b.style.color = '';
    }, 2000);
  }
}
// Fallback, falls Inline-onclick="addCart()" genutzt wird
function addCart() {
  var f = hbdForm();
  if (f) { f.requestSubmit ? f.requestSubmit() : f.submit(); }
  else { hbdAdded(); }
}

// ─── Farb-/Varianten-Auswahl ───
function pColor(el, name, hex, variantId, img) {
  document.querySelectorAll('.prod-color-o').forEach(function (b) { b.classList.remove('on'); });
  el.classList.add('on');
  var cN = document.getElementById('cN'); if (cN) cN.textContent = name;
  var v = document.getElementById('variantId'); if (v && variantId) v.value = variantId;
  if (img) { var mi0 = document.getElementById('pMainImg'); if (mi0) mi0.src = img; }
  // (Falls die Produktgrafik ein Inline-SVG mit diesen IDs ist – beim GIF No-op)
  ['pW', 'pI', 'pH', 'pB'].forEach(function (id) {
    var e = document.getElementById(id); if (!e) return;
    var f = e.getAttribute('fill'), s = e.getAttribute('stroke');
    if (f && f !== 'none' && f !== '#fff') e.setAttribute('fill', hex);
    if (s && s !== 'none') e.setAttribute('stroke', hex);
  });
  document.querySelectorAll('.pS').forEach(function (s) { s.setAttribute('stroke', hex); });
}

// ─── Galerie-Bildwechsel (Thumbnail-Klick) ───
function swapImg(url, el) {
  if (!url) return;
  var mi = document.getElementById('pMainImg'); if (mi) mi.src = url;
  document.querySelectorAll('.prod-thumb').forEach(function (t) { t.classList.remove('on'); });
  if (el) el.classList.add('on');
}

// ─── Kompatibilitäts-Check ───
function chkC() {
  var v = document.getElementById('cI').value.trim();
  if (!v) return;
  var r = document.getElementById('cR');
  r.className = 'compat-res show';
  r.innerHTML = '<strong>' + v + '</strong> ist kompatibel mit Hubbeldidupp ✓';
}

// ─── FAQ-Akkordeon ───
function tFaq(b) {
  var a = b.nextElementSibling, ar = b.querySelector('.faq-arr');
  var open = a.style.maxHeight && a.style.maxHeight !== '0px';
  document.querySelectorAll('.faq-a').forEach(function (el) { el.style.maxHeight = '0'; });
  document.querySelectorAll('.faq-arr').forEach(function (el) { el.classList.remove('open'); });
  if (!open) { a.style.maxHeight = a.scrollHeight + 'px'; ar.classList.add('open'); }
}

// ─── Newsletter ───
function sub() {
  var b = document.querySelector('.nl-sub-btn');
  if (b) b.textContent = '✓ Willkommen!';
  var i = document.getElementById('nlE'); if (i) i.value = '';
  setTimeout(function () { if (b) b.textContent = 'Anmelden'; }, 3000);
}

// ─── Automatisch gebundene Listener ───
function hbdInit() {
  var nav = document.getElementById('nav');
  if (nav) window.addEventListener('scroll', function () {
    nav.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });

  // ─── Mobile-Menü ───
  var mob = nav ? nav.querySelector('.nav-mob') : null;
  if (nav && mob) {
    mob.addEventListener('click', function () { nav.classList.toggle('menu-open'); });
    nav.querySelectorAll('.nav-links a').forEach(function (a) {
      a.addEventListener('click', function () { nav.classList.remove('menu-open'); });
    });
  }

  var obs = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('vis'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.rv').forEach(function (el) { obs.observe(el); });

  var form = hbdForm();
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var vid = (document.getElementById('variantId') || {}).value;
      if (!vid) { hbdAdded(); return; } // Vorschau ohne Produkt: nur visuelles Feedback
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(new FormData(form))
      })
        .then(function (r) { return r.json(); })
        .then(function () { hbdAdded(); })
        .catch(function () {
          var b = document.getElementById('cB');
          if (b) {
            b.textContent = 'Fehler — bitte erneut versuchen';
            setTimeout(function () { b.textContent = 'In den Warenkorb · ' + fmtPrice(unitCents() * qty); }, 2000);
          }
        });
    });
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hbdInit);
else hbdInit();
